import Vue from 'vue'
import Router from 'vue-router'
import v from 'voca'
import functions from './functions'

Vue.use(Router)

function load(component) {
  return () => import(`./views/${component}`)
}

const list = functions.map((f) => {
  return { path: f.link, component: load(f.component) }
})

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/', component: load('index')
    },
  ]
})

router.addRoutes(list)

export default router